export default __webpack_public_path__ + "static/media/login-sound.06c6e080.mp3";